export default {
  // Promotions Admin
  "userPromotionsAdmin.add": "添加",
  "userPromotionsAdmin.details": "详情",
  "userPromotionsAdmin.edit": "编辑",
  "userPromotionsAdmin.delete": "删除",
  "userPromotionsAdmin.delete.confirm.title": "删除配置",
  "userPromotionsAdmin.delete.confirm.content": "确定要删除这个配置吗？",
  "userPromotionsAdmin.delete.confirm.okText": "确定",
  "userPromotionsAdmin.delete.confirm.cancelText": "取消",
  "userPromotionsAdmin.modal.title": "促销配置",
  "userPromotionsAdmin.thead.createdAt": "创建时间",
  "userPromotionsAdmin.thead.updatedAt": "更新时间",
  "userPromotionsAdmin.thead.action": "操作",
  "userPromotionsAdmin.thead.dialogConfig": "弹窗配置",
  "userPromotionsAdmin.dialogConfig.title": "弹窗标题",
  "userPromotionsAdmin.dialogConfig.content": "弹窗内容",
  "userPromotionsAdmin.dialogConfig.btnText": "按钮文本",
  "userPromotionsAdmin.dialogConfig.url": "链接",
  "userPromotionsAdmin.dialogConfig.mobilePosition": "显示位置",
  "userPromotionsAdmin.dialogConfig.position.center": "居中",
  "userPromotionsAdmin.dialogConfig.position.bottom": "底部",
  "userPromotionsAdmin.dialogConfig.position.top": "顶部",
  "userPromotionsAdmin.dialogConfig.img": "弹窗图",
  "userPromotionsAdmin.dialogConfig.img.change": "更换图片",
  "userPromotionsAdmin.dialogConfig.showBgColor": "显示弹窗背景色",
  "userPromotionsAdmin.dialogConfig.preLoginPolicy": "登录前弹窗方式",
  "userPromotionsAdmin.dialogConfig.postLoginPolicy": "登录后弹窗方式",
  "userPromotionsAdmin.dialogConfig.policy.none": "不弹窗",
  "userPromotionsAdmin.dialogConfig.policy.daily": "每日一次",
  "userPromotionsAdmin.dialogConfig.policy.high": "高频弹窗",
  "userPromotionsAdmin.dialogConfig.policy.eachLogin": "每次登录",
  "userPromotionsAdmin.dialogConfig.policy.onceOnly": "只弹一次",

  // 砍价转盘/抽奖相关字段
  "userPromotionsAdmin.thead.target": "砍一刀总目标是",
  "userPromotionsAdmin.thead.expireDays": "未完成目标失效时间",
  "userPromotionsAdmin.thead.loginChance": "每天登录获得砍1刀机会",
  "userPromotionsAdmin.thead.referralChance": "邀请好友并绑定CPF身份",
  "userPromotionsAdmin.thead.totalSpin": "需要砍多少刀才能完成任务",

  // 字段悬浮提示
  "userPromotionsAdmin.tips.target": "说明转盘的目标类型或对象。",
  "userPromotionsAdmin.tips.expireDays": "奖励/机会的有效天数，超过该天数后自动失效。",
  "userPromotionsAdmin.tips.loginChance": "用户登录可获得的每日抽奖次数。",
  "userPromotionsAdmin.tips.referralChance": "邀请好友成功后额外获得的抽奖次数。",
  "userPromotionsAdmin.tips.totalSpin": "活动期间可使用的抽奖总次数上限。",

  // Promotion fields
  "userPromotionsAdmin.thead.id": "ID",
  "userPromotionsAdmin.thead.documentId": "文档ID",
  "userPromotionsAdmin.thead.sort": "排序",
  "userPromotionsAdmin.thead.itemName": "活动名称",
  "userPromotionsAdmin.thead.itemId": "活动ID",
  "userPromotionsAdmin.thead.content": "内容",
  "userPromotionsAdmin.thead.listToDdetailText": "按钮文本",
  "userPromotionsAdmin.thead.listOpenType": "打开方式",
  "userPromotionsAdmin.thead.listOpenUrl": "活动详情链接",
  "userPromotionsAdmin.thead.openPaymentBindBonusId": "绑定奖金ID",
  "userPromotionsAdmin.thead.itemSubName": "子名称",
  "userPromotionsAdmin.thead.isMessage": "是否消息",
  "userPromotionsAdmin.thead.publishedAt": "发布时间",
  "userPromotionsAdmin.thead.locale": "语言环境",
  "userPromotionsAdmin.thead.banner": "横幅",
  "userPromotionsAdmin.thead.seo": "SEO",
  "userPromotionsAdmin.thead.groupKey": "活动分类",
  "userPromotionsAdmin.thead.listTitleIcon": "标题图标",
  "userPromotionsAdmin.thead.bindSite": "绑定站点",
  "userPromotionsAdmin.thead.type": "活动类型",
  "userPromotionsAdmin.thead.displayFlag": "显示标记",
  "userPromotionsAdmin.thead.createdBy": "创建者",
  "userPromotionsAdmin.thead.updatedBy": "更新者",
  "userPromotionsAdmin.thead.localizations": "本地化",
  "userPromotionsAdmin.thead.status": "状态",

  // 新增字段本地化
  "userPromotionsAdmin.thead.startTime": "开始时间",
  "userPromotionsAdmin.thead.endTime": "结束时间",
  "userPromotionsAdmin.thead.active": "激活状态",
  "userPromotionsAdmin.thead.userGroupRules": "用户分组规则",
  "userPromotionsAdmin.thead.vipRules": "VIP 规则",
  "userPromotionsAdmin.dialogConfig.unloggedBehavior.none": "不校验登录",
  "userPromotionsAdmin.dialogConfig.unloggedBehavior.openLogin": "打开登录",
  "userPromotionsAdmin.dialogConfig.unloggedBehavior.openRegister": "打开注册",
  "userPromotionsAdmin.thead.channels": "渠道",
  "userPromotionsAdmin.thead.participationWay": "参与方式",
  "userPromotionsAdmin.thead.bonusPayoutStrategy": "奖金发放策略",
  "userPromotionsAdmin.thead.theNextDay": "次日领取",
  "userPromotionsAdmin.thead.realTime": "实时领取(影响留存)",
  "userPromotionsAdmin.vipRules.all": "全部",
  // 选项本地化
  "userPromotionsAdmin.participationWay.auto": "自动",
  "userPromotionsAdmin.participationWay.signUp": "报名",
  "userPromotionsAdmin.bonusPayoutStrategy.auto": "自动(系统自动发放)",
  "userPromotionsAdmin.bonusPayoutStrategy.manual": "人工(运营手工发放)",
  "userPromotionsAdmin.bonusPayoutStrategy.userCollection": "用户自领",
  "userPromotionsAdmin.thead.eventType": "事件类型",
  "userPromotionsAdmin.thead.collectionTimeType": "领取时间",
  "userPromotionsAdmin.thead.collectionTime": "选择时间",
  "userPromotionsAdmin.thead.rewardExpirationDays": "奖励领取过期天数",
  "userPromotionsAdmin.eventType.register": "注册",
  "userPromotionsAdmin.thead.bonusAmount": "奖励金额",
  "userPromotionsAdmin.thead.wager": "流水金额",

  // 启用/停用确认（参考 deposit-bonus-admin）
  "userPromotionsAdmin.active.confirm.title": "启用配置",
  "userPromotionsAdmin.active.confirm.content": "确定要启用该配置吗？",
  "userPromotionsAdmin.active.confirm.okText": "确定",
  "userPromotionsAdmin.deactive.confirm.title": "停用配置",
  "userPromotionsAdmin.deactive.confirm.content": "确定要停用该配置吗？",
  "userPromotionsAdmin.deactive.confirm.okText": "确定",

  // SEO fields
  "userPromotionsAdmin.thead.metaTitle": "Meta标题",
  "userPromotionsAdmin.thead.metaDescription": "Meta描述",
  "userPromotionsAdmin.thead.metaImage": "Meta图片",
  "userPromotionsAdmin.thead.keywords": "关键词",
  "userPromotionsAdmin.thead.metaRobots": "Meta Robots",
  "userPromotionsAdmin.thead.metaViewport": "Meta Viewport",
  "userPromotionsAdmin.thead.canonicalURL": "规范URL",
  "userPromotionsAdmin.thead.structuredData": "结构化数据"
};
